import Step1 from "./images/step-one.jpg";
import Step2 from "./images/step-two.jpg";
import Step3 from "./images/step-three.jpg";
import Step4 from "./images/step-four.jpg";

export const BECOME_OWNER = [
    {
        icon: Step1,
        title: "Step 1",
        description: "Register your interest to start the application process"
    },
    {
        icon: Step2,
        title: "Step 2",
        description: "We will get in touch with you and guide you on the next steps"
    },
    {
        icon: Step3,
        title: "Step 3",
        description: "Our team conducts a quick eligibility verification"
    },
    {
        icon: Step4,
        title: "Step 4",
        description: "Align with CARS24 standards and start franchise operations"
    }
];
